import { render, staticRenderFns } from "./o-container.vue?vue&type=template&id=7118576e&"
import script from "./o-container.vue?vue&type=script&lang=js&"
export * from "./o-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports